module.exports = __webpack_public_path__ + "static/media/radar.e9f410be.svg";